import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CheckboxConfig } from '../../../model';

/**
 * * Componente de checkboxes do Apolo
 */
@Component({
  selector: 'ui-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  /**
   * * Título para o grupo de checkboxes.
   */
  @Input() title!: string;
  /**
   * * Name para os inputs do grupo.
   */
  @Input() name!: string;
  /**
   * * Lista de Valores Selecionados.
   */
  @Input() checkedValues!: string[];
  /**
   * * Lista de Valores Desabilitados.
   */
  @Input() disabledValues!: string[];
  /**
   * * Lista de Opções de configuração das Checkboxes.
   */
  @Input() options!: CheckboxConfig[];

  // css
  /**
   * * Habilitar classe css inline.
   */
  @Input() inline: boolean = false;
  /**
   * * Habilitar classe css wrap.
   */
  @Input() wrap: boolean = false;

  /**
   * * Evento emitido ao selecionar/deselecionar checkbox, 
   * * retornando uma lista de valores selecionados.
   */
  @Output() check = new EventEmitter<string[]>();

  constructor() { }

  ngOnInit(): void {
  }

  isChecked(value: string): boolean {
    return this.checkedValues?.filter(v => v == value ).length > 0;
  }

  isDisabled(value: string): boolean {
    return this.disabledValues?.filter(v => v == value ).length > 0;
  }

  emitChekedValue() { // emite array com values de checkboxes com o mesmo "name" checkados
    const inputs: HTMLElement[] = Array.from(document.getElementsByName(this.name));
    const values = inputs.filter((input) => (input as HTMLInputElement).checked).map(input => (input as HTMLInputElement).value);
    this.check.emit(values);
  }

}
